import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, NEVER } from 'rxjs';
import {JobProcedureService} from '../services/sections/job/job-procedure.service';
import {GlobalSettingsService} from '../services/ui/global-settings.service';
import {catchError, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProcedurePreApprovalResolver implements Resolve<any> {
    constructor(
      private router: Router,
      private procedureService: JobProcedureService
    ) {}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
      GlobalSettingsService.isSecondaryLoaderLoading = true;

      return this.procedureService
        .getProcedurePreApprovalRequest(route.paramMap.get('token'))
        .pipe(
          catchError(() => {
            this.router.navigate(['/404']);
            GlobalSettingsService.isSecondaryLoaderLoading = false;
            return NEVER;
          }),
          tap((result) => {
            GlobalSettingsService.preferencesPayloadForJobDetails.procedurePreApprovalRequestDetails = result;
          }),
        );
    }
}
